import { gql } from '@apollo/client'

export default gql`
    mutation partnerRunSync($GroupID: String!) {
        partnerRunSync(GroupID: $GroupID)
    }
`
